import { useNavigate } from "react-router";
import { auth } from "../../../App/routes";
import Button from "../../../utils/components/Button";
import SelectBox from "../../../utils/components/SelectBox";
import NewTaskAssignmentModal from "./NewTaskAssignmentModal";
import FormStartModal from "./FormStartModal";
import Modal from "../../../utils/components/Modal";

const FormHeader = ({
  isReadOnly,
  selectedStatus,
  setSelectedStatus,
  setIsReadOnly,
  isCreateOptionsModalOpen,
  setIsCreateOptionsModalOpen,
  isWorkflowCreateModalOpen,
  setIsWorkflowCreateModalOpen,
  isNewTaskAssignmentModalOpen,
  setIsNewTaskAssignmentModalOpen,
  isSendingFromParent,
  isLock,
  setIsLock,
  statusData,
  handleSaveForm,
  translate,
  taskData,
  workflowTemplates,
  template,
  isSendingForm,
  canCreateTask,
  canCreateWorkflow,
}) => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);

  return (
    <>
      <div
        className={`row flex-column-reverse flex-lg-row mt-4 pb-4 border-bottom border-2 ${
          isReadOnly ? "d-none" : "d-flex"
        }`}
      >
        <div className="col-12 col-lg-3 d-flex justify-content-center justify-content-lg-start">
          <Button
            className="btn-secondary px-5 ms-0 ms-lg-4 mt-2 mt-lg-0"
            onClick={() => {
              if (searchParams.get("return"))
                navigate(searchParams.get("return"));
              else navigate(auth.forms.link);
            }}
            disabled={isSendingForm}
          >
            {translate("cancel")}
          </Button>
        </div>
        <div className="col-12 col-lg-4 mt-2 mt-lg-0">
          <SelectBox
            options={statusData}
            placeholder={translate("forms.place-holders.select-status")}
            value={selectedStatus}
            onChange={(selectedStatus) => setSelectedStatus(selectedStatus)}
            disabled={isReadOnly || isSendingForm}
          />
        </div>
        <div className="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
          <Button
            className="btn-orange text-white px-5"
            onClick={handleSaveForm}
            disabled={isSendingForm}
          >
            {translate("save")}
          </Button>
          <Button
            className="btn-orange text-white px-5 ms-5"
            onClick={() => {
              if (canCreateTask && canCreateWorkflow)
                setIsCreateOptionsModalOpen(!isCreateOptionsModalOpen);
              else if (canCreateTask) setIsNewTaskAssignmentModalOpen(true);
              else if (canCreateWorkflow) setIsWorkflowCreateModalOpen(true);
            }}
            disabled={isSendingForm}
          >
            {translate("send")}
          </Button>

          {(canCreateTask || canCreateWorkflow) && (
            <Modal
              show={isCreateOptionsModalOpen}
              setShow={() =>
                setIsCreateOptionsModalOpen(!isCreateOptionsModalOpen)
              }
            >
              <div className="d-flex align-items-center justify-content-around">
                {canCreateTask && (
                  <Button
                    className="btn-secondary px-5"
                    onClick={() => {
                      setIsNewTaskAssignmentModalOpen(
                        !isNewTaskAssignmentModalOpen
                      );
                      setIsCreateOptionsModalOpen(!isCreateOptionsModalOpen);
                    }}
                  >
                    {translate("forms.create-task")}
                  </Button>
                )}
                {canCreateWorkflow && (
                  <Button
                    className="btn-secondary px-5"
                    onClick={() => {
                      setIsWorkflowCreateModalOpen(!isWorkflowCreateModalOpen);
                      setIsCreateOptionsModalOpen(!isCreateOptionsModalOpen);
                    }}
                  >
                    {translate("forms.create-workflow")}
                  </Button>
                )}
              </div>
            </Modal>
          )}
          {canCreateTask && (
            <NewTaskAssignmentModal
              show={isNewTaskAssignmentModalOpen}
              hideModal={() =>
                setIsNewTaskAssignmentModalOpen(!isNewTaskAssignmentModalOpen)
              }
              translate={translate}
              handleSaveForm={(sendData, type) =>
                handleSaveForm(null, sendData, type)
              }
              users={taskData?.users}
              companies={taskData?.companies}
              groups={taskData?.groups}
            />
          )}
          {canCreateWorkflow && (
            <FormStartModal
              show={isWorkflowCreateModalOpen}
              hideModal={() =>
                setIsWorkflowCreateModalOpen(!isWorkflowCreateModalOpen)
              }
              translate={translate}
              handleSaveForm={(sendData, type) =>
                handleSaveForm(null, sendData, type)
              }
              users={taskData?.users}
              companies={taskData?.companies}
              groups={taskData?.groups}
              workflowTemplates={workflowTemplates}
              template={template}
              isSendingFromParent={isSendingFromParent}
              isSendingForm={isSendingForm}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FormHeader;
